/*******************************************************************************
 *                                                                             *
 * WARNING! This file was automatically generated from the server-side model!  *
 * You shouldn't edit this by hand.  If you want to modify the client-side     *
 * model behavior, you should modify: ../ModelDeductCodeEdi.ts                 *
 *                                                                             *
/*******************************************************************************/

import { Endpoint, ModelRow, RowConstructor } from "@mcleod/core";

const endpointPath = "lme/datafusion/deduct-code-edi";

export class AutogenModelDeductCodeEdi<RowType extends ModelRow> extends Endpoint<RowType, RowDeductCodeEdiFields> {
	constructor(ctor: RowConstructor) {
		super(endpointPath, ctor);
	}
}

export class AutogenRowDeductCodeEdi extends ModelRow<RowDeductCodeEdiFields> {
	constructor(values?: Partial<RowDeductCodeEdiFields>) {
		super(endpointPath, true, values);
	}
}

export interface RowDeductCodeEdiFields {
	charge_code_id: string;
	company_id: string;
	deduct_code_id: string;
	edi_deduct_code: string;
	id: string;
	partner_id: string;
	version: string;
}

